<template>
    <div class="field">
        <div class="control has-icons-left">
            <datetime
                    :class="{ 'is-danger': error && error.length > 0 }"
                    input-class="input"
                    v-model="date"
                    :format="{year: 'numeric',  month: 'numeric', day: 'numeric'}"
                    type="date"
                    value-zone="local"
                    zone="local"
                    input-id="shipped_cars"
                    placeholder="Purchase date"
            ></datetime>
            <span class="icon is-small is-left">
                <i class="fas fa-calendar"></i>
            </span>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
    </div>
</template>

<script>
    import { Datetime } from 'vue-datetime'
    export default {
        components: {
            Datetime
        },
        computed: {
            date: {
                get: function () {
                    return this.$store.getters.getNewCarDate
                },
                set: function (value) {
                    this.$store.dispatch('setNewCarDate', value)
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorDate
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/DateSelect.vue